module.exports = __webpack_public_path__ + "static/poster-6e6515cf6f5c40669dbdb66b1c44a531.jpg";